import * as React from 'react'

function SvgScheduleCanceled(props, svgRef) {
  return (
    <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        clipRule="evenodd"
        d="M4.75 5.097c-.414 0-.75.339-.75.757V16.46c0 .419.336.758.75.758h10.5c.414 0 .75-.34.75-.758V5.854a.754.754 0 00-.75-.757H4.75zm-2.25.757a2.261 2.261 0 012.25-2.272h10.5a2.261 2.261 0 012.25 2.272V16.46a2.262 2.262 0 01-2.25 2.273H4.75A2.262 2.262 0 012.5 16.46V5.854z"
      />
      <path
        clipRule="evenodd"
        d="M13 2.066c.414 0 .75.34.75.758v3.03a.754.754 0 01-.75.758.754.754 0 01-.75-.758v-3.03c0-.418.336-.758.75-.758zM7 2.066c.414 0 .75.34.75.758v3.03a.754.754 0 01-.75.758.754.754 0 01-.75-.758v-3.03c0-.418.336-.758.75-.758z"
      />
      <path d="M7.5 14.566l5-5M7.5 9.566l5 5" stroke="#204667" strokeWidth={1.5} strokeLinecap="round" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgScheduleCanceled)
export default ForwardRef
